import { render, staticRenderFns } from "./anquan.vue?vue&type=template&id=47002592&scoped=true"
import script from "./anquan.vue?vue&type=script&lang=js"
export * from "./anquan.vue?vue&type=script&lang=js"
import style0 from "./anquan.vue?vue&type=style&index=0&id=47002592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47002592",
  null
  
)

export default component.exports